/**
 * FSH research page image pop-up.
 *
 * Any button with data-fsh-zoom opens its image large, in one shared dialog.
 * The dialog closes on the X, on a click outside the panel, and on Escape.
 * If the button sits in a figure, the figure's caption goes with the image.
 *
 * data-fsh-zoom-src sets the large file. Without it, the image in the button
 * is used as it is.
 */
(function () {
  if (window.__fshZoomReady) return;
  window.__fshZoomReady = true;

  var dialog = null;
  var image = null;
  var caption = null;
  var frame = null;
  var opener = null;
  var root = document.documentElement;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'fsh-zoom';
    dialog.setAttribute('aria-label', 'Enlarged image');

    var panel = document.createElement('div');
    panel.className = 'fsh-zoom__panel';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'fsh-zoom__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';
    close.addEventListener('click', function () {
      dialog.close();
    });

    image = document.createElement('img');
    image.className = 'fsh-zoom__image';
    image.decoding = 'async';

    // On a phone the image is wider than the screen and pans sideways here.
    frame = document.createElement('div');
    frame.className = 'fsh-zoom__frame';
    frame.appendChild(image);

    caption = document.createElement('div');
    caption.className = 'fsh-zoom__caption';

    panel.appendChild(close);
    panel.appendChild(frame);
    panel.appendChild(caption);
    dialog.appendChild(panel);

    // The dialog has no padding and the panel fills it, so a click that
    // lands on the dialog itself is a click on the backdrop.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      root.classList.remove('fsh-zoom-open');
      // Back to the chart that opened it, so a keyboard reader keeps their place.
      if (opener) opener.focus({ preventScroll: true });
      opener = null;
    });

    document.body.appendChild(dialog);
  }

  function open(trigger) {
    if (!dialog) build();
    opener = trigger;

    var source = trigger.querySelector('img');
    image.src = trigger.getAttribute('data-fsh-zoom-src') || (source && (source.currentSrc || source.src)) || '';
    image.alt = source ? source.alt : '';

    var figure = trigger.closest('figure');
    var text = figure && figure.querySelector('figcaption');
    caption.innerHTML = text ? text.innerHTML : '';
    caption.hidden = !text;

    root.classList.add('fsh-zoom-open');
    dialog.showModal();
    frame.scrollLeft = 0;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fsh-zoom]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
})();
